import { post, postExFile, postFile } from "@utils/httpUtil";

// 医生列表-批量导入打标签
export function batchAddLabelByExcel(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postFile(`/c/pc/community/doctor/v2/batchAddLabelByExcel`, data, config);
}
// 医生列表-下载导入打标签失败
export function importExternalAccountFailDoctorData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/admin/sp/externalAccount/importExternalAccountFailDoctorData`, data, config);
}
// 医生列表-下载打标签模板
export function downloadImportLabelExcelTemplateFiles(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/downloadImportLabelExcelTemplateFiles`, data, config);
}
// 医生列表-列表
export function doctorGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/v2/getPageInfo`, data, config);
}
// 上下架, 根据入参状态更新;
export function doctorOnlineByStatus(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/v2/onlineByStatus`, data, config);
}
// 上下架, 根据id删除;
export function doctorDeleteById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/v2/deleteById`, data, config);
}
// 上下架, 导出数据
export function doctorExportData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/community/doctor/v2/exportData`, data, config);
}
// 医生详情
export function doctorGetDoctorDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/v2/getDoctorDetail`, data, config);
}
// 医生详情
export function getDoctorServerData(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/v2/getDoctorServerData`, data, config);
}
// 医生详情
export function getWeiboInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/getWeiboInfo`, data, config);
}
// 医生详情
export function configSetting(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/configSetting/get`, data, config);
}
// 医生详情
export function getCommunityHotDoctor(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/communityHotDoctor/get`, data, config);
}
export function configSettingEdit(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/configSetting/edit`, data, config);
}
export function communityHotDoctorEdit(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/community/doctor/communityHotDoctor/edit`, data, config);
}

// 医生列表 - 保存消息推送;
export function saveDoctorMessageCustom(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pccommunity/message/v2/saveDoctorMessageCustom`, data, config);
}
// 医生列表 - 编辑消息推送;
export function updateDoctorMessageCustom(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pccommunity/message/v2/updateDoctorMessageCustom`, data, config);
}
export function messageFindDoctorPageMessage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pccommunity/message/v2/findDoctorPageMessage`, data, config);
}
// 医生列表 - 查询消息详情 - 列表;
export function findDoctorMessageDetailList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pccommunity/message/v2/findDoctorMessageDetailList`, data, config);
}
export function deleteMessage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pccommunity/message/v2/deleteMessage`, data, config);
}
export function cancelMessage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pccommunity/message/v2/cancelMessage`, data, config);
}
// 医生列表 - 查询消息详情 - 列表;
export function exportDoctorMessageDetailList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pccommunity/message/v2/exportDoctorMessageDetailList`, data, config);
}
